import { useCallback } from 'react';

import socket from '@/services/socket';
import { BUILD_NUMBER } from '@/settings';

export const useLog = () => {
  const log = useCallback((context: string, additionalData: any) => {
    socket.emit('log', {
      additionalData,
      context: `nutror.front.${context}`,
      environment: 'nutrorv3'
    });
  }, []);

  const activity = useCallback((context: string, additionalData: any) => {
    socket.emit('log', {
      additionalData: {
        action: context,
        referer: window.location.href,
        version: BUILD_NUMBER,
        ...additionalData
      },
      context: `nutror.user.${context}`,
      environment: 'nutror-activity'
    });
  }, []);

  return {
    log,
    activity
  };
};
